'use client';

import React from 'react';
import { NextIntlClientProvider } from 'next-intl';
import { resolveTranslations } from '@mentimeter/i18n-core';
import { getLocaleFromCookieOnClient } from '@mentimeter/i18n-core/get-locale-from-cookie-on-client';
import { messages as ragnarMessages } from '@mentimeter/i18n-ragnar';
import { messages as purchasingMessages } from '../index';

export const NextIntlPurchasingProvider = ({
  children,
}: React.PropsWithChildren) => {
  const locale = getLocaleFromCookieOnClient();
  const [messages, _] = React.useState(() =>
    resolveTranslations(locale, purchasingMessages, ragnarMessages),
  );

  return (
    <NextIntlClientProvider messages={messages} locale={locale}>
      {children}
    </NextIntlClientProvider>
  );
};
